import { escapePanelAttribute } from "../panel-markdown"

interface TurndownRule {
	filter: (node: Node) => boolean
	replacement: (content: string, node: Node) => string
}

interface TurndownLike {
	addRule: (key: string, rule: TurndownRule) => void
}

const typeOf = (node: Node): string | null =>
	node.nodeType === 1 ? (node as HTMLElement).getAttribute("data-type") : null

const elementChildren = (node: Node): HTMLElement[] =>
	Array.from(node.childNodes).filter(
		(child): child is HTMLElement => child.nodeType === 1,
	)

function entryLines(node: HTMLElement, depth: number): string[] {
	const pad = "  ".repeat(depth)
	const type = typeOf(node)
	if (type === "tree-file") {
		const name = escapePanelAttribute(node.textContent?.trim() ?? "")
		return [`${pad}<Tree.File name="${name}" />`]
	}
	if (type !== "tree-folder") return []
	const children = elementChildren(node)
	const label = children.find((child) => typeOf(child) === "tree-name")
	const name = escapePanelAttribute(label?.textContent?.trim() ?? "")
	const open =
		node.hasAttribute("open") || node.getAttribute("data-open") === "true"
	const inner = children.flatMap((child) => entryLines(child, depth + 1))
	return [
		`${pad}<Tree.Folder name="${name}"${open ? " defaultOpen" : ""}>`,
		...inner,
		`${pad}</Tree.Folder>`,
	]
}

// The component syntax, not the list one: only it keeps a folder closed.
export function addTreeMarkdownRules(turndown: TurndownLike): void {
	turndown.addRule("mintlifyTree", {
		filter: (node) => node.nodeName === "DIV" && typeOf(node) === "tree",
		replacement: (_content, node) => {
			const lines = elementChildren(node).flatMap((child) =>
				entryLines(child, 1),
			)
			return `\n\n<Tree>\n${lines.join("\n")}\n</Tree>\n\n`
		},
	})
}
